export default __webpack_public_path__ + "static/media/sitka-small-599.ca7897ca.ttf";